import { css } from '@emotion/css'
import { spacing } from '@offerzen/pinata-shame'

const styles = {
  wrapper: css({
    display: 'flex',
    alignItems: 'center',

    // Override Pinata TabBar styling since it doesn't allow for customisation
    ul: {
      border: 'none',
      marginLeft: spacing.small,
    },
  }),
}

export default styles
